/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { useAppSelector } from "hooks/reduxHooks";
import { associateProduct } from "api/services/product.api";
import { IGetAssociatedProduct } from "interfaces/ClientInterface/IProduct";
import { Artifisettings } from "api/IProduct";
import { LoadingOutlined } from "@ant-design/icons";
import { AxiosError, AxiosResponse } from "axios";
import { Col, Row } from "antd";
import ProductCard from "./ProductCard/ProductCard";
import ArtifiIntegration from "./ArtifiIntegration";
import "./Product.scss";

interface ProductListingProps {
  artifConfigurations: Artifisettings | undefined;
}

const ProductListing: React.FC<ProductListingProps> = ({
  artifConfigurations,
}: ProductListingProps) => {
  const publishCatalogId: number =
    useAppSelector((state) => state.landingPage.publishCatalogId) || 0;
  const portalId: number = useAppSelector((state) => state.landingPage.portalId) || 0;
  const [products, setProducts] = useState<IGetAssociatedProduct[]>([]);
  const [showArtifi, setShowArifi] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const antIcon = (
    <LoadingOutlined className="spinner" spin style={{ fontSize: "30px", color: "blue" }} />
  );

  const gettingPortalDetails = () => {
    setIsLoading(true);
    if (portalId && publishCatalogId) {
      associateProduct(portalId, publishCatalogId)
        .then((response: AxiosResponse<any, any>) => {
          setProducts(
            response?.data?.PublishProducts.sort(
              (a: any, b: any) => a?.DisplayOrder - b?.DisplayOrder
            )
          );
          setIsLoading(false);
        })
        .catch((error: AxiosError) => {
          setIsLoading(false);
          throw error;
        });
    }
  };

  useEffect(() => {
    gettingPortalDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publishCatalogId, portalId]);

  return (
    <>
      {isLoading ? (
        antIcon
      ) : (
        <Row gutter={[15, 15]} className="product-grid-wrapper">
          {products &&
            products.map((item: any) => {
              return (
                <Col key={item?.DesignId} xs={12} md={8} lg={4} xxl={4} xl={4}>
                  <ProductCard
                    key={item?.DesignId + item?.ImageSmallPath}
                    product={item}
                    imageUrl={item?.ImageSmallPath}
                    titleText={item?.Name}
                    setShowArifi={setShowArifi}
                    setSelectedProduct={setSelectedProduct}
                  />
                </Col>
              );
            })}
        </Row>
      )}

      {showArtifi && (
        <ArtifiIntegration
          artifConfigurations={artifConfigurations}
          setShowComponent={setShowArifi}
          selectedRecord={selectedProduct}
        />
      )}
    </>
  );
};

export default ProductListing;
